var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIpo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2557AF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h66L0,66V0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,28.9l2.1-2.1l10.5,10.5l-2.1,2.1L8,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,24.5l3.4-3.4c2.3-2.3,4.9-3.3,7.4-0.8c2.4,2.4,1.7,5.3-0.6,7.5l-1.4,1.4l3.7,3.7L22.9,35L12.4,24.5z  M20.9,26.2c1.4-1.4,1.5-2.7,0.3-3.9c-1.2-1.2-2.4-0.9-3.8,0.6L16.2,24l3.4,3.4L20.9,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2,21c-3.4-3.4-3.5-7.3-0.7-10.1c2.8-2.8,6.7-2.7,10.1,0.7c3.4,3.4,3.6,7.4,0.8,10.2S29.6,24.4,26.2,21z  M33.5,13.8c-2.2-2.2-4.6-2.6-6.1-1s-1.2,3.9,1,6.1c2.2,2.2,4.7,2.7,6.2,1.1S35.7,16.1,33.5,13.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpo);
export default __webpack_public_path__ + "static/media/icon_ipo.4d036f7a03164afde247d1906cd03ad1.svg";
export { ForwardRef as ReactComponent };